import React from 'react'

export interface ProvingGround {
  _id: string
  title: string
  abbr: string
}
export const ProvingGroundsContext = React.createContext([] as ProvingGround[])
